/**
 * operatorCode - the ONLY thing a staff badge may show (Bill 2026-09-11 ruling:
 * Core operator initials, never a first/last-name derivation). Users.OfficerCode
 * is Core-Director-resolved; CartBootstrapStep falls back to the UPN local part
 * when a user has none, and that fallback must not render as if it were a code.
 */
export function isOperatorCode(v: string | null | undefined): boolean {
  return /^[A-Za-z0-9]{1,4}$/.test((v ?? '').trim());
}

export function operatorCode(v: string | null | undefined): string {
  return isOperatorCode(v) ? (v ?? '').trim().toUpperCase() : '';
}
